import { ProgressStatus } from "../../../hooks/attestations/config";
import { ErrorMessage, BalanceDisplay, CostDetails, ActionButton } from "./index";

// Extracted MintingProcessContent component
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MintingProcessContent = _ref => {
  let {
    status,
    balance,
    notEnoughFunds,
    isLoadingEstimation,
    gasEstimation,
    isConnected,
    handleSwitchChain,
    handleAttest,
    isLoading,
    attestationFee
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col gap-6 items-start justify-center w-full",
    children: [status === ProgressStatus.IS_ERROR && /*#__PURE__*/_jsx(ErrorMessage, {}), /*#__PURE__*/_jsx(BalanceDisplay, {
      balance: balance,
      notEnoughFunds: notEnoughFunds
    }), /*#__PURE__*/_jsx(CostDetails, {
      isLoading: isLoadingEstimation,
      attestationFee: attestationFee,
      estimatedGas: gasEstimation
    }), /*#__PURE__*/_jsx(ActionButton, {
      isConnected: isConnected,
      status: status,
      handleSwitchChain: handleSwitchChain,
      handleAttest: handleAttest,
      notEnoughFunds: notEnoughFunds,
      isLoading: isLoading
    })]
  });
};